// src/components/admin/design/CategoriesPreview.tsx
"use client";

import React from "react";
import { CATEGORY_VARIANTS } from "@/components/store/sections/categories";
import { useDetectedAdminTheme } from "./UniversalProductCardPreview";

export interface CategoriesPreviewProps {
  variantId: string;
  primaryColor?: string;
  theme?: "dark" | "light";
}

const MOCK_CATEGORIES = [
  { id: 1, name: "Bags & Wallets", slug: "bags-wallets", icon: "👜", products_count: 12 },
  { id: 2, name: "Beauty & Care", slug: "beauty-care", icon: "💄", products_count: 34 },
  { id: 3, name: "Bedroom Decor", slug: "bedroom-decor", icon: "🛏️", products_count: 8 },
  { id: 4, name: "Healthy Foods", slug: "healthy-foods", icon: "🥦", products_count: 45 },
  { id: 5, name: "Jewelry & Accs", slug: "jewelry-accs", icon: "💍", products_count: 29 },
  { id: 6, name: "Kids & Baby", slug: "kids-baby", icon: "🧸", products_count: 15 },
  { id: 7, name: "Men's Fashion", slug: "mens-fashion", icon: "👔", products_count: 52 },
  { id: 8, name: "Shoes & Sneakers", slug: "shoes-sneakers", icon: "👟", products_count: 38 },
  { id: 9, name: "Smart Gadgets", slug: "smart-gadgets", icon: "⌚", products_count: 19 },
  { id: 10, name: "Women's Fashion", slug: "womens-fashion", icon: "👗", products_count: 74 },
];

export default function CategoriesPreview({
  variantId = "notch_ribbon",
  primaryColor = "#059669",
  theme: propTheme,
}: CategoriesPreviewProps) {
  const [activeTheme] = useDetectedAdminTheme(propTheme);
  const isLight = activeTheme === "light";

  const cleanKey = String(variantId || "notch_ribbon")
    .trim()
    .toLowerCase()
    .replace(/-/g, "_");
  const CategoryComponent =
    CATEGORY_VARIANTS[cleanKey] || CATEGORY_VARIANTS["notch_ribbon"];

  return (
    <div
      data-xylo-preview-theme={activeTheme}
      className={`w-full overflow-hidden rounded-2xl p-2 transition-colors ${
        isLight ? "text-slate-900" : "text-slate-100 dark"
      }`}
    >
      <CategoryComponent categories={MOCK_CATEGORIES} primaryColor={primaryColor} />
    </div>
  );
}